import React from "react";
import "./appointment.scss";
import Button from "../../Common/Button/Button";
import doct from "../../../assets/UMSImage/Dr_without_background_Circle.png"
import bg from "../../../assets/UMSImage/bg-appointment.png"
import bgDoc from "../../../assets/UMSImage/appointment-bg-icon.png"

const Appointment = () => {
  return (
    <>
      <section id="appointment-wrapper">
        {/* <img src={bg} alt="" className="bg-image" />
        <img src={bgDoc} alt=""   className="bg-image"/> */}
        <div className="row appointment">
          <div className="col-lg-6 doct">
            <div className="appointmnet-image">
                <img src={doct} alt="" />
            </div>
          </div>
          <div className="col-lg-6 content">
            <p>APPOINTMENT</p>
            <h2>
              Get Free Billing <span>Audit</span>
            </h2>
            <div className="appointment-btn">
            <Button id="arrow-wrapper-right">Appointment</Button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Appointment;